import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from './../../common/Pagination';
import moment from 'moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { formatDate, parseDate } from 'react-day-picker/moment';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';
import { findPermission } from './../../../utils';

class Table extends Component {
    static propTypes = {
        elements: PropTypes.array,
        handleSort: PropTypes.func,
        handleUpdateFormValue: PropTypes.func,
        isFetchingElements: PropTypes.bool,
        handleShowForm: PropTypes.func,
        handleShowDelete: PropTypes.func,
        totalPages: PropTypes.number,
        selectedPage: PropTypes.number,
        elementsPerPage: PropTypes.number,
        sortColumn: PropTypes.string,
        sortType: PropTypes.string,
        handleChangeAttribute: PropTypes.func,
        handleInlineChange: PropTypes.func,
        handleViewProperty: PropTypes.func,
        handleChangeFilter: PropTypes.func,
        processedElements: PropTypes.array,
        user: PropTypes.object,
        filterFields: PropTypes.object
    };

    renderTableHeader(label, name, style, sortable = true) {
        const { handleSort, sortColumn, sortType } = this.props;

        let icon = <i className="fas fa-sort" />;
        if (sortColumn === name) {
            if (sortType === 'asc') {
                icon = <i className="fas fa-sort-up" />;
            } else {
                icon = <i className="fas fa-sort-down" />;
            }
        }

        if (sortable) {
            return <th style={style}><span onClick={handleSort.bind(this, name)}>{label} {icon}</span></th>;
        }

        return <th style={style}>{label}</th>;
    }

    renderData() {
        const { processedElements, isFetchingElements, handleShowForm, handleShowDelete, selectedPage, elementsPerPage,
            user } = this.props;

        if (isFetchingElements) {
            return (
                <tr>
                    <td colSpan="9"><i className="fas fa-circle-notch fa-spin" /> Loading data...</td>
                </tr>
            );
        }

        if (processedElements.length === 0) {
            return (
                <tr>
                    <td colSpan="9">No Results</td>
                </tr>
            );
        }

        let permission = findPermission(user['permissions'], 'Change Order');

        let data = [];
        let startIndex = (selectedPage - 1) * elementsPerPage;
        for (let i = startIndex; i < processedElements.length && i < startIndex + elementsPerPage; i++) {
            let className = '';
            if (processedElements[i]['edited']) {
                className = 'edited';
            } else if (processedElements[i]['notes'] !== null && processedElements[i]['notes'] !== '') {
                className = 'noticed';
            }

            let editAction = null;
            if (permission['Create'] || permission['Enter Costs']) {
                editAction = (
                    <Tooltip title="Edit" position="bottom" arrow size="small" className="action-tooltip">
                        <i className="fas fa-edit" onClick={handleShowForm.bind(this, processedElements[i].id, null)} />
                    </Tooltip>
                );
            }

            let deleteAction = null;
            if (permission['Delete']) {
                deleteAction = (
                    <Tooltip title="Delete" position="bottom" arrow size="small" className="action-tooltip">
                        <i className="fas fa-trash" onClick={handleShowDelete.bind(this, processedElements[i].id)} />
                    </Tooltip>
                );
            }

            data.push(
                <tr key={i} className={className}>
                    <td>{moment(processedElements[i]['date']).format('MM/DD/YYYY')}</td>
                    <td>{processedElements[i]['pm_number']}</td>
                    <td>{processedElements[i]['customer']}</td>
                    <td>{processedElements[i]['sales_name']}</td>
                    <td>{processedElements[i]['csr_name']}</td>
                    <td>{processedElements[i]['department_name']}</td>
                    <td>{processedElements[i]['chargeable'] ? 'Yes' : 'No'}</td>
                    <td>{processedElements[i]['reason']}</td>
                    <td>
                        <div className="actions">
                            {editAction}
                            {deleteAction}
                        </div>
                    </td>
                </tr>
            );
        }

        return data;
    }

    renderSearchField(name) {
        const { handleChangeFilter } = this.props;
        return (
            <th className="search-th">
                <input type="text" name={name} className="search-input" onChange={handleChangeFilter.bind(this, name)} />
            </th>
        );
    }

    renderSearchSelect(name, options) {
        const { handleChangeFilter } = this.props;
        return (
            <th className="search-th">
                <select type="text" name={name} className="search-input" onChange={handleChangeFilter.bind(this, name)} >
                    {options.map((option, index) => {
                        return (
                            <option key={index} value={option['value']}>{option['label']}</option>
                        );
                    })}
                </select>
            </th>
        );
    }

    render() {
        const { processedElements, totalPages, selectedPage, elementsPerPage,
            handleChangeFilter } = this.props;
        return (
            <div id="tables-container" className="production-container">
                <div className="table-container table-hover">
                    <table id="titles-table" className="table table-sm table-hover">
                        <thead>
                            <tr>
                                {this.renderTableHeader('Date', 'date', { width: 162 })}
                                {this.renderTableHeader('PM #', 'pm_number')}
                                {this.renderTableHeader('Customer', 'customer')}
                                {this.renderTableHeader('Sales', 'sales_name')}
                                {this.renderTableHeader('CSR', 'csr_name')}
                                {this.renderTableHeader('Department', 'department_name')}
                                {this.renderTableHeader('Chargeable', 'chargeable')}
                                {this.renderTableHeader('Comments', 'reason')}
                                <th style={{ width: 80 }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th className="search-th multiple-date">
                                    <DayPickerInput
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        placeholder=""
                                        format="MM/DD/YY"
                                        onDayChange={handleChangeFilter.bind(this, 'start_date')}
                                    />
                                    <div className="float-left ml-1 mr-1">to</div>
                                    <DayPickerInput
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        placeholder=""
                                        format="MM/DD/YY"
                                        onDayChange={handleChangeFilter.bind(this, 'end_date')}
                                    />
                                </th>
                                {this.renderSearchField('pm_number')}
                                {this.renderSearchField('customer')}
                                {this.renderSearchField('sales_name')}
                                {this.renderSearchField('csr_name')}
                                {this.renderSearchField('department_name')}
                                {this.renderSearchSelect('chargeable', [
                                    { label: '', value: '' },
                                    { label: 'Yes', value: 1 },
                                    { label: 'No', value: 0 }
                                ])}
                                {this.renderSearchField('reason')}
                                <th className="search-th"></th>
                            </tr>
                            {this.renderData()}
                        </tbody>
                    </table>
                    <Pagination.Container
                        totalItems={processedElements.length}
                        totalPages={totalPages}
                        selectedPage={selectedPage}
                        elementsPerPage={elementsPerPage}
                    />
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

export default Table;
